import { Base } from "ui/Scripts/source/framework/base";
import { IReportChartDataSet, ReportChartDataSet } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/report/reportChartDataSet";
import { AppChartType, ChartValueFormatting } from "ui/Scripts/source/models/enums";

export interface IDashboardChartData {
    dataId: string;
    title: string;
    chartType: AppChartType;
    labels: string[];
    dataSets: IReportChartDataSet[];
    yAxisValueFormatting: ChartValueFormatting;
}

export class DashboardChartData implements IDashboardChartData {
    dataId: string;
    title: string;
    chartType: AppChartType;
    labels: string[];
    dataSets: ReportChartDataSet[];
    yAxisValueFormatting: ChartValueFormatting;

    constructor();
    constructor(obj: IDashboardChartData);
    constructor(obj?: any) {
        this.dataId = obj && obj.dataId || "";
        this.title = obj && obj.title || "";
        this.chartType = obj && obj.chartType || AppChartType.BarChart;
        this.labels = obj && obj.labels || [];
        this.dataSets = Base.getTypedArray(obj ? obj.dataSets : null, ReportChartDataSet);
        this.yAxisValueFormatting = obj && obj.yAxisValueFormatting || ChartValueFormatting.None;
    }
}